<script>

	import { starData, indSlide, indSel, margCorrect, formSubmitted, scrollTrigger} from './stores.js';
	
	import * as animateScroll from "svelte-scrollto";

	let ind_Sel = {i:-1,h:-1};
	let selStars = [];
	export let drawOutlines;

	let dim = {};

	let submitted = false; // true if user has submitted a response from <Form>
	let triggered = false;
	let focussed = false;

	let marg_str;

	let hasStars = false;

	export let cols;

	let input = {
		col:-1,
		ind:-1
	}

	let timers = {
		sel:null
	}

	const handleClick = (e,i) => {

		if (e.type == 'keypress') {
			const code = e.charCode || e.keyCode;
			if (code != 32 && code != 13) return;
		}

		animateScroll.scrollToTop({duration:500});

		if (ind_Sel['i'] == -1) return;

		input['ind'] = i;
		ind_Sel['i'] = i;

		indSel.set({
			i:i,
			h:Math.random()
		});
	}

	const triggerClick = (e) => {

		if (e.type == 'keypress') {
			const code = e.charCode || e.keyCode;
			if (code != 32 && code != 13) return;
		}
		
		triggered = true;

		scrollTrigger.set(true);

		

		clearTimeout(timers['sel']);
		timers['sel'] = setTimeout(() => {
			scrollTrigger.set(false);
			triggered = false;
		},2000);
	}

	const setStars = () => {
		// ind_Sel['i'] = 0;

		hasStars = true;
	}

	const unsubscribe_allstar = starData.subscribe(values => {
		//console.log(value)
		//if (Object.keys(values).length == 0) return;

		if (values.length ==0) return;

		selStars = values;

		//selStars = values.map((row,i) => values[values.length-1-i]);

		// console.log('Starfield.svelte <-- Wall.svelte (starData)')
		// console.log(selStars);

		setStars();
	});

	const unsubscribe_slide = indSlide.subscribe(value => {
		//console.log('unsubscribe_slide ' + value)
		if (value == -1) return;

		ind_Sel['i'] = value;

		// console.log('Starfield.svelte <-- Wall.svelte (indSlide)');
		// console.log(`ind_Sel: ${ind_Sel}`);

	});

	const unsubscribe_marg = margCorrect.subscribe(obj => {
		dim['marg'] = obj.margx; // assign correct margin from Wall
		dim['w'] = obj.w;
		dim['scl'] = obj.scl;

		// not exactly centred, but aligned over the arrow
		dim['margL'] = dim['marg'] -dim['scl'];
		dim['margR'] = 0.5*dim['marg'] - 1.5*dim['scl'];
		if (dim['margR'] < 0) {dim['margR'] = 0;}

		marg_str = `margin-left:${0.5*dim['margL']}px; margin-right:${dim['margR']}px;`
	});

	const unsubscribe_formSubmitted = formSubmitted.subscribe(value => {
		submitted = value;

		// console.log('Starfield.svelte <-- Form.svelte (submitted)');
		// console.log(`submitted: ${submitted}`);
	});

	const getSvgPaths = () => {

		let e = {
			x:[0,100],
			y:[0,100]
		}

		let s = { x:0,y:12 };

		let r= {y:25}


		let star = {
			d: `
				M${20+s.x} ${50+s.y} L${80+s.x} ${50+s.y} 
				M${50+s.x} ${20+s.y} L${50+s.x} ${80+s.y} 

				M${25+s.x} ${25+s.y} L${75+s.x} ${75+s.y} 
				M${75+s.x} ${25+s.y} L${25+s.x} ${75+s.y}
			`,
			r:`
				M${e.x[0]} ${e.y[0]} L${e.x[0]} ${e.y[1]} 
				M${e.x[1]} ${e.y[1]} L${e.x[1]} ${e.y[0]} 

				M${e.x[0]} ${e.y[1]} L${e.x[1]} ${e.y[1]} 
				M${e.x[1]} ${e.y[0]+r.y} L${e.x[0]} ${e.y[0]+r.y}

			`, // order above ^^ left/right/bottom/top
			v:`
				0 25 100 75
			`
		};

		return star
	}

	let starPath = getSvgPaths();

	// let star_d = `
	// 	M20 50 L80 50 
	// 	M50 20 L50 80 
	// 	M25 25 L75 75 
	// 	M75 25 L25 75
	// `;

	// let star_r = ` 
	// 	M0 0 L0 100 
	// 	M0 100 L100 100 
	// 	M100 100 L100 0 
	// 	M100 0 L0 0
	// `;

</script>



<svg viewBox={starPath['v']} style="display:none;">
	<style>
		.box {
			fill: transparent;
			stroke: white;
			stroke-width: 4px;
		}
	</style>
	<defs>
	  <g id="rect">
	   <path class="box" d={starPath['r']}/>
	   <path d={starPath['d']}/>
	  </g>
	   <g id="star">
	   <path d={starPath['d']}/>
	  </g>
	</defs>
</svg>

{#if hasStars}
	
		<div id="starHolder" style={drawOutlines ? `${marg_str} border:1px solid red` : `${marg_str}`}>
			
			{#if !submitted}
				<svg viewBox={starPath['v']} width={dim['scl']} on:click={e => {triggerClick(e)}} on:keypress={e => {triggerClick(e)}} tabindex="0" class="active" style="stroke:{cols[cols.length-1]['hex']} ">  <!-- on:focus={() => {scrollFocus.set(true)}} on:blur={() => {scrollFocus.set(false)}} -->
					<title>{`${cols[cols.length-1]['desc']} star`}</title>
					<desc>Add your response.</desc>
					{#if triggered}
						<use xlink:href="#rect" x="0" y="0"/>
					{:else}
						<use xlink:href="#star" x="0" y="0"/>
					{/if}
				</svg>
			{/if}
			{#each selStars as star,i}
				<svg viewBox={starPath['v']} width={dim['scl']} on:click={e => {handleClick(e,i)}} on:keypress={e => {handleClick(e,i)}} tabindex="0" class="{ind_Sel['i'] === i && !triggered ? `active` : ``}" style="stroke:{cols[star.Colour]['hex']}">
					{#if ind_Sel['i'] === i && !triggered}
						<title>{`${cols[star.Colour]['desc']} star (selected)`}</title>
						<desc>{`This star is selected.`}</desc>
						<use xlink:href="#rect" x="0" y="0"/>
					{:else}
						<title>{`${cols[star.Colour]['desc']} star`}</title>
						<desc>Select to display on the wall.</desc>
						<use xlink:href="#star" x="0" y="0"/>
					{/if}
				</svg>
			{/each}
		
		<!-- </div> -->
		</div>
	
{:else}
	<div class="pd">
		<p><em>Loading Responses ...</em></p>
	</div>
{/if}

<style>

	.pd {
		padding:100px;
	}
	#starHolder {
		display:flex;
		flex-flow: row wrap;
		justify-content:flex-start;
		align-items:flex-start;
		
		/*text-align:left;*/
	}

	svg {
		opacity:0.6;
		stroke-width:10px;
		fill: transparent;
		cursor:pointer;
		/*transform: rotate(90deg);*/
	}

	svg:hover {
		opacity:1;
		transform: scale(1.2)
	}

	.active {
		opacity:1;
	}
	

</style>
